import { Alert } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * Итог отправки звонков на транскрибацию: по каким условиям выполнен отбор
 * и какие записи ушли на распознавание.
 */
export type C1ToAsrSendSummaryData = {
  /** Начало интервала отбора */
  dateFrom: string;
  /** Конец интервала отбора */
  dateTo: string;
  /** Значение линии, по которому выполнен отбор */
  line: string;
  /** Максимум звонков, заданный в условиях отбора */
  limit?: number;
  /** Отправка выполнена с обогащением; иначе — обработка без шагов с LLM */
  isEnrichEnabled: boolean;
  /** ID отправленных записей */
  conversationIds: number[];
};

type Props = {
  summary: C1ToAsrSendSummaryData;
};

export const C1ToAsrSendSummary: FC<Props> = ({ summary }) => {
  const { t } = useTranslation(['integrations']);

  return (
    <Alert
      type="success"
      title={t('integrations:c1ToAsr.summary.title')}
      description={
        <div className="flex flex-col gap-2">
          <span>
            {t('integrations:c1ToAsr.summary.conditions', {
              dateFrom: summary.dateFrom,
              dateTo: summary.dateTo,
              line: summary.line,
              limit: summary.limit,
            })}
          </span>
          <span>
            {summary.isEnrichEnabled
              ? t('integrations:c1ToAsr.summary.modeEnrich')
              : t('integrations:c1ToAsr.summary.modeNoEnrich')}
          </span>
          <span>{t('integrations:c1ToAsr.summary.sentCount', { count: summary.conversationIds.length })}</span>
          <div className="flex flex-wrap gap-2">
            {summary.conversationIds.map((id) => (
              <Link key={id} to={`/dialogs/${id}`} className="text-primary text-sm underline hover:text-primary/80">
                {id}
              </Link>
            ))}
          </div>
        </div>
      }
    />
  );
};
